/* eslint-disable */
import types from './types';
import { get } from 'utils/api';
import { ARTICLES_TOTAL } from 'snippets/latesArticles';

/** Загрузка страниц автора */
/** Загрузка данных для страницы автора
 * @param {string} author
 * @param {number} page - номер страницы
 * @param {string} sort - значение сортировки
 * @returns {object}
 */
const loadAuthorStart = (author, page, sort) => ({
  type: types.LOADING_AUTHOR_START,
  author,
  page,
  sort,
});

/** Успешная загрузка данных для категории
 * @param {string} author
 * @param {object} data
 * @returns {object}
 */
const loadAuthorStop = (author, data) => ({
  type: types.LOADING_AUTHOR_STOP,
  author,
  data,
});

/** Ошибка загрузки данных для категории
 * @param {string} author
 * @param {object} error
 * @returns {object}
 */
const loadAuthorFail = (author, error) => ({
  type: types.LOADING_AUTHOR_FAILURE,
  author,
  error,
});

/** Запрос на получение данных категории
 * @param {string} author
 * @param {number} page - номер страницы
 * @param {string} sort - значение сортировки
 * @returns {Promise}
 */
const loadAuthor = (author, page, sort, category) => dispatch => {
  dispatch(loadAuthorStart(author, page, sort)); // Начало загрузки

  return get({ url: `/articles/author/${author}`, data: { page, sort, category } })
    .then(data => dispatch(loadAuthorStop(author, data)))
    .catch(error => {
      dispatch(loadAuthorFail(author, error));
      return Promise.reject(error);
    });
};

/** Загрузка категории если она не загружена
 * @param {string} author
 * @param {number} page - номер страницы
 * @param {string} sort - значение сортировки
 * @returns {Promise}
 */
export const loadAuthorIfNotLoaded = (author, page, sort, category) => (dispatch, getState) => {
  const { pages } = getState().author;
  const { isLoaded, isLoading } = pages[author] || {};

  if (!isLoaded && !isLoading) {
    return dispatch(loadAuthor(author, page, sort, category));
  } else {
    return null;
  }
};

/** Смена номера страницы
 * Действие также меняет и сортировку(sort)
 */
const changePage = (page, sort) => ({
  type: types.CHANGE_PAGE,
  page,
  sort,
});

/** Действие начала подгрузки статей
 * @param {string} author
 * @param {number} page - новая страница
 */
const startLoadArticle = (author, page) => ({
  type: types.LOADING_ARTICLES_START,
  author,
  page,
});

/** Добавление номера загруженной страницы
 * @param {string} author
 * @param {number} page
 * @param {string} sort
 */
const pushLoadedPage = (author, page, sort) => ({
  type: types.PUSH_LOADED_PAGE,
  author,
  page,
  sort,
});

/** Действие удачной подгрузки статей
 * @param {string} author
 * @param {number} page - новая страница
 * @param {string} sort - значение сортировки
 * @param {object} latesArticle
 */
const stopLoadArticle = (author, page, sort, latesArticle) => ({
  type: types.LOADING_ARTICLES_STOP,
  author,
  page,
  sort,
  latesArticle,
});

/** Действие ошибки подгрузки статей
 * @param {string} author
 * @param {error} error
 */
const failureLoadArticle = (author, error) => ({
  type: types.LOADING_ARTICLES_FAILURE,
  author,
  error,
});

/** Подгрузка статей в категорию
 * @param {string} author
 * @param {number} page
 * @param {string} sort
 * @param {number} total
 */
const getArticlesInAuthor = (author, page, sort, category, total) => (dispatch, getState) => {
  dispatch(startLoadArticle(author, page)); // Начало загрузки

  const { profile } = getState();

  const consumerId = profile.id;
  const headers = consumerId ? { ['X-Consumer']: consumerId } : {};

  return get({
    url: '/articles/list',
    data: { author, page, total, sort, category },
    headers
  })
    .then(data =>
      dispatch(
        stopLoadArticle(author, page, sort, {
          total: data.total,
          items: data.items,
        }),
      ),
    )
    .catch(error => dispatch(failureLoadArticle(author, error)));
};

/** Подгрузка статей.
 * Данное действие запускается только после загрузки данных
 * страницы автора - loadAuthorIfNotLoaded()
 *
 * @param {string} author
 * @param {number} page
 * @param {string} sort
 */
export const loadArticles = (author, page, sort, category) => (dispatch, getState) => {
  const { isLoadingArticles } = getState().author;

  // Проверяет, идет ли сейчас загрузка и были ли
  // загружены статьи для запрашиваемой страницы
  if (!isLoadingArticles) {
    return dispatch(getArticlesInAuthor(author, page, sort, category, ARTICLES_TOTAL));
  }

  // Если страница была загружена и сейчас не идет подгрузка
  if (!isLoadingArticles) {
    return dispatch(changePage(page, sort)); // Смена номера страницы;
  }

  return null;
};
